import { createAction, props } from '@ngrx/store';
import { ScheduleMisfireHandling } from 'mbs-ui-shared@models/schedule-misfire.handling';
import { GroupTask, GroupTaskOsTypes } from '../rmmGroupTasks/model';
import { StoreTypes } from '../storeTypes.enum';
import {
  GroupActionsCommands,
  LinuxAvailableActions,
  MacAvailableActions,
  ScheduleState,
  SelectedEntities,
  WindowsAvailableActions,
  WizardGroupAction
} from './model';

export const setGActionName = createAction(`[${StoreTypes.RmmGroupActionWizard}] Set Name`, props<{ name: string }>());
export const setGActionOsType = createAction(`[${StoreTypes.RmmGroupActionWizard}] Set OS`, props<{ osType: GroupTaskOsTypes }>());
export const setGActionSelectedType = createAction(
  `[${StoreTypes.RmmGroupActionWizard}] Set Selected Type from Action`,
  props<{ actionSelectCommand: WindowsAvailableActions | LinuxAvailableActions | MacAvailableActions }>()
);

export const setGActionNameAndOsTypeAndCommandType = createAction(
  `[${StoreTypes.RmmGroupActionWizard}] Set Name, OS and Type from Select Action Step`,
  props<{
    name: string;
    osType: GroupTaskOsTypes;
    actionSelectCommand: WindowsAvailableActions | LinuxAvailableActions | MacAvailableActions;
  }>()
);

export const setGActionApplyTo = createAction(`[${StoreTypes.RmmGroupActionWizard}] Set ApplyTo`, props<{ applyTo: SelectedEntities }>());

export const setGActionCommandType = createAction(
  `[${StoreTypes.RmmGroupActionWizard}] Set Actual Command`,
  props<{ groupActionCommand: GroupActionsCommands }>()
);

export const setGActionParameters = createAction(
  `[${StoreTypes.RmmGroupActionWizard}] Set Parameters for Actual Command`,
  props<{ parameters: Partial<GroupTask> }>()
);

export const setGActionSchedule = createAction(`[${StoreTypes.RmmGroupActionWizard}] Set Schedule`, props<{ schedule: ScheduleState }>());
export const setGActionScheduleMisfireHandling = createAction(
  `[${StoreTypes.RmmGroupActionWizard}] Set Misfire Handling`,
  props<{ misfireHandling: ScheduleMisfireHandling }>()
);
export const resetGActionSchedule = createAction(`[${StoreTypes.RmmGroupActionWizard}] Reset Schedule`);

export const saveGActionChanges = createAction(`[${StoreTypes.RmmGroupActionWizard}] Save Changes to Existing GAction`);
export const saveNewGAction = createAction(`[${StoreTypes.RmmGroupActionWizard}] Create GAction`);

export const successGroupAction = createAction(`[${StoreTypes.RmmGroupActionWizard}] Complete Successfully`);
export const resetGActionWizard = createAction(`[${StoreTypes.RmmGroupActionWizard}] Reset Wizard`);
export const setupGroupTask = createAction(
  `[${StoreTypes.RmmGroupActionWizard}] Set Wizard Group Task`,
  props<{ wizardGroupAction: Partial<WizardGroupAction> }>()
);
